import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {DigitalSceneProps} from "./types";
import {
    EntryOptions,
    PropertyDefinition, PropertyMappingType
} from "app/library/layout-builder";
import {CardPropertyDefinitions, VideoDefinition} from "../../definitions";
import {MetaTypeEnum} from "../../../../app/shared";

export class DigitalSceneDefinitions extends CmsReactComponent<DigitalSceneProps> {

    static schemaName = "digital-scene";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "videos",
            description: "Video Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: VideoDefinition,
            },
        },
        {
            name: "cards",
            description: "Kart List Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: CardPropertyDefinitions,
            }
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "title",
                text: "Dijital Sahne Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "description",
                text: "Dijital Sahne Açıklaması",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "video",
                text: "Dijital Sahne Video",
                types: [MetaTypeEnum.SingleVideo],
            },
            {
                name: "startDate",
                text: "Dijital Sahne Başlangıç Tarihi",
                types: [MetaTypeEnum.Date],
            },
            {
                name: "endDate",
                text: "Dijital Sahne Bitiş Tarihi",
                types: [MetaTypeEnum.Date],
            },
        ],
    };


}
